'use client';

import * as React from 'react';
import FormControlContext from './FormControlContext';
export default function useFormControl() {
  return React.useContext(FormControlContext);
}


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormControl/useFormControl.js
// module id = 104
// module chunks = 25